export const styles = {
  container: { display: "flex", alignItems: "center" },
  formControlLabel: {
    margin: 0,
  },
}
